import { render, staticRenderFns } from "./VeTextBlock.vue?vue&type=template&id=8197718a&scoped=true"
import script from "./VeTextBlock.vue?vue&type=script&lang=js"
export * from "./VeTextBlock.vue?vue&type=script&lang=js"
import style0 from "./VeTextBlock.vue?vue&type=style&index=0&id=8197718a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8197718a",
  null
  
)

export default component.exports